module.exports = __webpack_public_path__ + "static/img/学而思教育平板xPad.7081b94c.png";